export default {
    setUnities(state, unities) {
        state.unities = [...unities];
    }
}